import { loadStripe } from "@stripe/stripe-js";

export const APP_CHARGING = "charging";
export const PRIV_ADMIN = "admin";
export const PRIV_CREATEDEAL = "createdeal";

// segment button
export const SEGMENT_PAYMENT = "product";

// reducer actions
export const PS_FAILED = "failed"; // charge failed. stuck.
export const PS_UNSCHEDULED = "unscheduled"; // charged, expected to fail (card expiry)
export const PS_SCHEDULED = "scheduled"; // charged, expected to succeed
export const PS_SUCCESS = "success"; // charged successfully
export const PS_DELETED = "deleted"; // paused=deleted by sales rep
export const PS_PENDING = "pending"; // backend currently processing

export const CARD_ELEMENT_OPTIONS = {
  hidePostalCode: true,
  disableLink: true,
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

export const stripePromise = loadStripe(process.env.REACT_APP_stripeCredential);
export const SEGMENT_PAYMENTPLAN = "paymentplan";

// redux tags
export const RT_STRIPECUSTOMER = "stripeCustomer";
export const RT_HUBSPOTCONTACT = "hubspotContact";
export const RT_SCHEDULEDPAYMENT = "scheduledPayment";
export const RT_PAYMENTMETHODS = "paymentMethods";
export const RT_DEALSFOREMAIL = "dealsForEmail";
export const RT_DEAL = "deal";

// max number of times to retry searching for a contact (1 second intervals) before giving up
export const HUBSPOTRETRIES = 10;
